import(/* webpackMode: "eager" */ "/home/runner/work/galapagos/galapagos/apps/web/src/app/error.tsx");
